import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "stars"
const StarsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.14 18.382C10.36 18.065 10.838 18.065 11.06 18.382L11.101 18.455 11.316 18.883 11.745 19.098C12.159 19.305 12.159 19.896 11.745 20.104L11.316 20.317 11.102 20.747C10.895 21.16 10.304 21.16 10.097 20.746L9.882 20.316 9.454 20.104C9.04 19.896 9.04 19.305 9.454 19.098L9.882 18.883 10.097 18.455z" />
          <path
            fillRule="evenodd"
            d="M15.823 11.795C16.27 11.044 17.391 11.069 17.793 11.871L18.346 12.978 19.455 13.532C20.282 13.947 20.282 15.128 19.454 15.543L18.346 16.097 17.793 17.204C17.378 18.032 16.197 18.032 15.783 17.204L15.226 16.097 14.121 15.543C13.293 15.128 13.293 13.947 14.12 13.533L15.227 12.977 15.782 11.87zM16.513 13.761C16.403 13.978 16.226 14.154 16.01 14.263L15.46 14.537 16.012 14.813C16.2 14.908 16.359 15.054 16.469 15.234L16.512 15.314 16.787 15.863 17.062 15.315 17.106 15.235C17.216 15.054 17.375 14.907 17.564 14.812L18.112 14.537 17.564 14.263C17.347 14.154 17.171 13.978 17.062 13.76L16.787 13.212zM7.573 3.545C8.02 2.794 9.141 2.819 9.543 3.621L10.849 6.226 13.454 7.532C14.282 7.947 14.282 9.128 13.454 9.543L10.848 10.849 9.544 13.454C9.128 14.282 7.947 14.282 7.533 13.454L6.224 10.85 3.621 9.543C2.793 9.128 2.793 7.947 3.62 7.533L6.225 6.225 7.532 3.62zM7.512 7.01C7.402 7.227 7.227 7.403 7.01 7.512L4.962 8.537 7.01 9.564C7.2 9.659 7.358 9.805 7.468 9.985L7.512 10.065 8.537 12.113 9.563 10.066 9.606 9.986C9.716 9.804 9.876 9.658 10.066 9.563L12.111 8.537 10.065 7.512C9.848 7.403 9.672 7.227 9.563 7.01L8.537 4.962z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default StarsIcon
